<div class="dashboard">
  <nav class="navbar">
    <div class="navbar-brand">
      <img src="assets/navbar logo.png" alt="Dashboard Logo" class="logo" />
      <h1>{{ pageTitle }}</h1> 
    </div>
    <div class="navbar-actions">
      <div class="dropdown">
        <button class="settings-btn">
          <img src="assets/profile.png" alt="Profile" class="profile-icon" />
        </button>
        <div class="dropdown-content">
          <button class="logout-btn" (click)="logout()">Logout</button>
        </div>
      </div>
    </div>
  </nav>

  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
